import { MouseEventHandler, ReactNode } from "react";
import styles from "./PTab.module.scss";

type PTabProps = {
  href?: string;
  id: string;
  isActive: boolean;
  onClick: MouseEventHandler<HTMLAnchorElement>;
  children: ReactNode;
};

export const PTab = ({
  href = "#",
  id,
  isActive,
  onClick,
  children,
}: PTabProps) => (
  <a
    href={href}
    id={id}
    className={`${styles.p_tab} ${isActive ? styles.active : ""}`}
    onClick={onClick}
  >
    {children}
  </a>
);
